import React from 'react';

import Fab from "@material-ui/core/Fab";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export default function Server  (){
    
  
    return (
        <>
        <div className="navbar-dark" style={{color:"white",backgroundColor:"#343A40"}}>
        
       
        <br/>
        <center>
        <input
            type="text"
            disabled
            value="How to download"
            style={{
              height: "57px",
              width: "200px",
              borderRadius: "5px",
              padding: "20px",
              color:"white",
              
              background: "#212121",
              border: "2px",
            }}
          />
            <Fab
            color="primary"
            
            style={{
              background: "#b71c1c",
              borderRadius: "7px",
              
            }}
            
          >
            <CloudDownloadIcon />
          </Fab>
          </center>
          <br/>
        </div>
        <div style={{color:"gray",backgroundColor:"#212121",height:"150%"}}>
          <br/>
          
         <ol>
           <li><b>Option 1</b></li>
           <i>Choose "HQ" and if movie is available click on download icon " <CloudDownloadIcon /> " to download using  uTorrent's magnet URL </i>
           <hr/>
           <li><b>Option 2</b></li>
           <i>Choose "HQ" and tap on movie name to download directly</i>
           <hr/>
           <li><b>Option 3</b></li>
           <i>Choose "HQ" and click on download button at bottom right </i>
           <hr/>
           <li><b>Option 4</b></li>
           <i>Use "Offline Downloader" extension on Chrome and download from any server. </i>
           <hr/>
          
         </ol>

        </div>



      
        </>
    )

}